/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN FEE REPORTS API
 * Role: Admin
 * Scope: Fetch financial metrics, revenue summaries, and defaulters list
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { apiCall } from "../core/apiCall";

const FEE_REPORTS_ENDPOINT = "/admin/fees/reports_summary.php";

/**
 * GET – Fetch Fee Reports Summary & Student Lists
 * @param {Object} params - Query filters { month, year, type ('monthly'|'yearly'|'overall') }
 * @param {Object} options - Additional API options
 */
export const getFeeReportsSummary = async (params = {}, options = {}) => {
  try {
    const res = await apiCall(
      "GET",
      FEE_REPORTS_ENDPOINT,
      null,
      "Admin – Fetch Fee Reports Summary",
      {
        params,
        ...options,
      }
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message: res?.message || "Failed to fetch fee reports summary",
        financial_summary: null,
        defaulters_list: [],
      };
    }

    // Combine paid and pending students into a unified list structure for Redux state,
    // while preserving counts and individual lists as sent by the backend PHP response.
    const paidStudents = res.lists?.paid_students || [];
    const pendingStudents = res.lists?.pending_students || [];
    const combinedLists = [...paidStudents, ...pendingStudents];

    return {
      success: true,
      filter_context: res.filter_context || {},
      financial_summary: res.financial_summary || {
        total_expected: 0.00,
        total_received: 0.00,
        total_pending: 0.00,
      },
      defaulters_count: res.counts?.pending_count || pendingStudents.length,
      // Store the organized lists structure directly so your frontend and selectors can access them
      defaulters_list: {
        counts: res.counts || { total_students: combinedLists.length, paid_count: paidStudents.length, pending_count: pendingStudents.length },
        lists: {
          paid_students: paidStudents,
          pending_students: pendingStudents,
        },
        all_students: combinedLists,
      },
    };
  } catch (error) {
    console.error("Admin Fetch Fee Reports Summary Error:", error);
    return {
      success: false,
      message: error.message || "Unexpected error occurred",
      financial_summary: null,
      defaulters_list: [],
    };
  }
};